import { render, staticRenderFns } from "./SearchResultItemGroup.vue?vue&type=template&id=f1021902&"
import script from "./SearchResultItemGroup.vue?vue&type=script&lang=ts&"
export * from "./SearchResultItemGroup.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultItemGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports